import { render, staticRenderFns } from "./FabricSimplePlaceholderImageControlsCard.vue?vue&type=template&id=bc1daba8&scoped=true"
import script from "./FabricSimplePlaceholderImageControlsCard.vue?vue&type=script&lang=js"
export * from "./FabricSimplePlaceholderImageControlsCard.vue?vue&type=script&lang=js"
import style0 from "./FabricSimplePlaceholderImageControlsCard.vue?vue&type=style&index=0&id=bc1daba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1daba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VIcon,VMenu,VSlider,VSpacer})
